import React from 'react';
import { Mui } from '@osu/react-ui';
import { SkipLinks } from '../ui';

/**
 * Main layout wrapper for the Student Dashboard
 * Provides consistent structure, accessibility features, and responsive container
 */
function DashboardLayout({ children, maxWidth = "lg" }) {
  return (
    <>
      <SkipLinks />

      {/* Live region for accessibility announcements */}
      <div
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
        role="status"
        style={{
          position: 'absolute',
          left: '-10000px',
          width: '1px',
          height: '1px',
          overflow: 'hidden'
        }}
      >
        Student Dashboard loaded successfully
      </div>

      <Mui.Container maxWidth={maxWidth} sx={{ py: 4 }}>
        {children}
      </Mui.Container>
    </>
  );
}

export default DashboardLayout;